import React from "react";

export default function VerticalPadding({ backgroundColor }) {
  return (
    <div className="vertical-padding-6pc" style={{ backgroundColor }}></div>
  );
}
